<template>
  <div>
    <div class="bg-white border-brand-sand border-2 rounded-xl relative">
      <div class="bg-brand-light-sand px-6 py-4 text-left rounded-tl-lg rounded-tr-lg border-b-2 border-brand-sand">
        <div class="absolute top-0 left-0 right-0 flex justify-left">
          <img class="-mt-5 ml-5" :src="imgPath" />
        </div>
        <h3 class="text-xl leading-6 mt-2 font-bold text-gray-900">
          {{ name }}
        </h3>
        <p v-if="description" class="mt-1 mb-1 text-md font-medium leading-5 text-brand-brown">{{ description }}</p>
      </div>
      <div class="px-6 py-6 text-sm font-medium text-brand-brown">
        <slot></slot>
      </div>
      <div class="text-left pl-6 pb-6">
        <el-button v-if="locked" type="primary">
          <font-awesome-icon :icon="['fas', 'angle-double-up']" class="mx-1" />
          Unlock with Churnkey Premium
        </el-button>
        <el-button v-loading="ctaLoading" v-else type="primary" @click="$emit('cta-click')">
          <span class="font-bold">{{ ctaText }}</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlowBaseStep',
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    ctaText: {
      type: String,
      required: false,
      default: 'Enable This Step →',
    },
    ctaLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    locked: {
      type: Boolean,
      required: false,
      default: false,
    },
    imgPath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
